import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link';
import FreshfundLogoRed from '../../assets/svg/freshfund-logo-red.svg';
import './application-header.scss';

const ApplicationHeader = ({ round, customClass }) => (
  <div className={`application-header application-header--round-${round} ${customClass}`}>
    <div className='application-header__right-trap' />
    <div className='application-header__left-trap' />

    <div className='application-header__container'>
      <div className='application-header__left'>
        <Link to='/about'>ABOUT</Link>
        <Link to='/judges/'>JUDGES</Link>
      </div>
      <div className='application-header__logo'>
        <Link to='/winners'>
          <FreshfundLogoRed />
        </Link>
      </div>

      <div className='application-header__right'>
        <Link to='/winners/'>CLASS OF 2022</Link>
        <Link to='/alumni/'>ALUMNI</Link>
      </div>
      <div className='application-header__mobile-links'>
        <Link to='/about'>ABOUT</Link>
        <Link to='/judges/'>JUDGES</Link>
        <Link to='/winners/'>CLASS OF 2022</Link>
        <Link to='/alumni/'>ALUMNI</Link>
      </div>
    </div>
  </div>
);

ApplicationHeader.defaultProps = {
  round: '2',
  customClass: '',
};

ApplicationHeader.propTypes = {
  round: PropTypes.string,
  customClass: PropTypes.string,
};

export default ApplicationHeader;
